import React, { useState } from 'react';
import { NavLink, useNavigate } from "react-router-dom";
import validator from 'validator';
import { forgotPassword } from "../../../services/AuthService";
import { toast } from "react-toastify";
import Utils from "../../../utils";
import Logo from '../../../assets/Images/Docusafe_logo.webp';
import './Auth.css';

// ✅ CustomInput import
import CustomInput from "../../../components/CustomInput";

function ForgotPassword() {
  const [loading, setLoading] = useState(false);
  const [isLink, setIsLink] = useState(false);
  const [email, setEmail] = useState('');

  let errorsObj = { email: '' };
  const [errors, setErrors] = useState(errorsObj);

  const navigate = useNavigate();

  const onForgot = (e) => {
    e.preventDefault();

    let error = false;
    const errorObj = { ...errorsObj };

    if (!email) {
      errorObj.email = "Email is required";
      error = true;
    } else if (!validator.isEmail(email)) {
      errorObj.email = "Please enter valid email address";
      error = true;
    }

    setErrors(errorObj);
    if (error) return;

    setLoading(true);

    forgotPassword({ email })
      .then(() => {
        setIsLink(true);
        setLoading(false);
      })
      .catch(err => {
        toast.error(Utils.getErrorMessage(err));
        setLoading(false);
      });
  };

  return (
    <div className="forgot-container">

      {loading && (
        <div className="page-loading">
          <img src="/images/loader.gif" alt="loader" />
        </div>
      )}

      <div className="login-card">

        <h3 className="login-title">Forgot Password</h3>

        {!isLink ? (
          <form onSubmit={onForgot}>
            
            {/* Email using CustomInput */}
            <div className="mb-3">
              <CustomInput
                label="Email"
                name="email"
                type="email"
                value={email}
                maxLength="50"
                onChange={(e) => setEmail(e.target.value)}
                placeholder="user@example.com"
                error={errors.email}
                required
              />
            </div>

            <button type="submit" className="login-btn-page w-100 mb-3">
              Send Reset Link
            </button>
          </form>
        ) : (
          <div className="success-message">
            <h4>Check Your Email</h4>

            <div style={{ marginBlock: "10px" }}>
              We have sent password reset instructions to your email address.
            </div>

            <div
              style={{
                color: "#888",
                fontSize: "0.97rem",
                marginBottom: "10px !important",
              }}
            >
              If you don't see the email, check your spam folder.
            </div>

            <button
              className="login-btn-page w-100 my-3"
              onClick={() => navigate("/login")}
            >
              Back to Login
            </button>
          </div>
        )}

        {!isLink && (
          <div className="login-footer">
            Remember your password?{" "}
            <NavLink to="/" className="login-link">Back to Login</NavLink>
          </div>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
